import { INVALIDATE_CREANCES, INVALIDATE_CREANCES_CLIENT, INVALIDATE_PAIEMENT_CREANCES } from "actions/invalidationTags";
import { ApiMananger } from "actions/rtkquery";
import {
  GET_ALL_CREANCES_API_ROUTE,
  GET_ALL_CREANCES_BY_USER_API_ROUTE,
  HISTORIQUE_PAIEMENT_CREANCE_API_ROUTE
} from "routes/api/endpoints";

const creancesApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    // USER
    getAllCreances: build.query({
      query: ({ dossier_id }) => `${GET_ALL_CREANCES_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
      providesTags: [INVALIDATE_CREANCES],
    }),
    getAllCreancesByUser: build.query({
      query: ({ client_id }) => `${GET_ALL_CREANCES_BY_USER_API_ROUTE}?client_id=${client_id}`,
      providesTags: [INVALIDATE_CREANCES_CLIENT],
    }),
    getCreanceById: build.query({
      query: ({ id, dossier_id }) => `${GET_ALL_CREANCES_API_ROUTE}${id}/?dossier_id=${dossier_id}`,
      providesTags: [INVALIDATE_CREANCES],
    }),
    getHistoriquePaiementCreance: build.query({
      query: ({ entree_id }) => `${HISTORIQUE_PAIEMENT_CREANCE_API_ROUTE}${entree_id}/historique/`,
      providesTags: [INVALIDATE_PAIEMENT_CREANCES],
    }),
    
  }),
});

export const {
  useGetAllCreancesByUserQuery,
  useGetAllCreancesQuery,
  useGetCreanceByIdQuery,
  useGetHistoriquePaiementCreanceQuery
} = creancesApi;
